import React, {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import axios from "axios";
import Card from "../../Components/Cards/Card";
import SubmitButton from "../../Components/Buttons/SubmitButton";
import swal from 'sweetalert';
import {useForm} from "react-hook-form";
import TextEditor from "../../Components/Inputs/TextEditor";
import TextareaInput from "../../Components/Inputs/TextareaInput";
import Switch from "../../Components/Inputs/Switch";

export default function () {
  const {
    reset,
    handleSubmit,
    register,
    control,
    watch,
    setValue
  } = useForm();

  const {id} = useParams()
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();

  useEffect(() => {
    axios.get(`settings/${id}/edit`).then(res => {
      if (res.data.status === 'success') {
        reset(res.data.setting);
      }
    });
  }, []);

  const edit = data => {
    axios.put(`settings/${id}`, data)
      .then(function (res) {
        if (res.status == 200) {
          swal('Setting has been updated successfully!', {
            icon: "success",
          });
          navigate("/general-settings");
        }
      })
      .catch(function (error) {
        if (error.response) {
          setErrors(error.response.data.errors || {});
        }
      });
  }

  const removeFormatting = () => {
    setValue('value', watch('value').replace(/<[^>]*>/g, '') || '')
  }

  return (
    <Card title="Edit Settings">
      <form className="form w-100 row" onSubmit={handleSubmit(edit)}>

        <Switch
          label="Editor Switch"
          name="editor"
          parentClasses="col-md-12 mt-10 active-notactive"
          register={register}
        />

        {
          watch('editor') ?
            <TextEditor
              control={control}
              name="value"
              label="Setting Value"
              errorMessage={errors?.value}
            />
            :
            <div className="row">
              <TextareaInput
                label="Setting Value"
                name="value"
                register={register}
                required={true}
                rows={3}
                watch={watch}
                errorMessage={errors?.value}
              />
              <button type="button"
                      className="btn btn-warning w-auto d-inline-block mx-3"
                      onClick={() => removeFormatting()}
              >
                <i className="fas fa-remove-format"></i>
                Remove Formatting
              </button>
            </div>
        }

        <SubmitButton
          title="Save"
          classes="w-auto d-inline-block float-right mt-5 mx-3"
        />
      </form>
    </Card>
  );
}